// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.right_image_container__tqLJW {
  position: relative;
  max-width: max-content;
  width: 100%;
  max-height: 90vh; }
  .right_image_container__tqLJW .right_img__s\\+zMj {
    height: 100%;
    width: 100%;
    object-fit: contain;
    object-position: top left; }

.right_oldCoord__n4P\\+c {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 20px;
  height: 20px;
  cursor: pointer;
  background: rgba(33, 33, 33, 0.6);
  color: #ffffff;
  font-weight: 400;
  font-size: 8px;
  line-height: 9px;
  overflow: hidden; }
`, "",{"version":3,"sources":["webpack://./src/pages/camera/modal/rightSectionZone/right.module.scss"],"names":[],"mappings":"AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,gBAAgB,EAAA;EAJlB;IAMI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,yBAAyB,EAAA;;AAI7B;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iCAAiC;EACjC,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB,EAAA","sourcesContent":["\n.image_container {\n  position: relative;\n  max-width: max-content;\n  width: 100%;\n  max-height: 90vh;\n  .img {\n    height: 100%;\n    width: 100%;\n    object-fit: contain;\n    object-position: top left;\n  }\n}\n\n.oldCoord {\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n  background: rgba(33, 33, 33, 0.6);\n  color: #ffffff;\n  font-weight: 400;\n  font-size: 8px;\n  line-height: 9px;\n  overflow: hidden;\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"image_container": `right_image_container__tqLJW`,
	"img": `right_img__s+zMj`,
	"oldCoord": `right_oldCoord__n4P+c`
};
export default ___CSS_LOADER_EXPORT___;
